import { gql } from "@apollo/client";

export const typeDef = gql`
  type PaymentMethods {
    name: String
    payment_method_id: Int
    payment_method_type_name: String
  }

  type Query {
    paymentMethods: [PaymentMethods]
  }
`;

export const resolvers = {
  Query: {
    paymentMethods: async (_parent, _args, { dataSources }) => {
      const res = await dataSources.paymentMethods.paymentMethods();
      return res.payment_methods;
    },
  },
};
